import Backbone from 'backbone'
import _ from 'lodash'

import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import selects from 'scoreboard/components/selects'

import template from './shape-text-config-view.hbs'
import {
	DATA_SOURCE,
	SPECIFIC_TEXT,
	NONE,
	SPECIFIC_FIELD
} from '../shape-text-type'
import { SHAPE_TEXT_TYPE, SHAPE_SPECIFIC_TEXT, SHAPE_TEXT_PROPERTY } from '../shape-widget-properties'

/**
 * Dialog view for the Set Text option in the shape widget's config menu
 */
const ShapeTextConfigView = Backbone.View.extend({
	className: 'shape-text-config-view',
	tagName: 'form',

	render () {
		this.$el.html(template({
			shapeTextPropertyLabel: 'scorecards.node.metric.series'
		}))

		this.renderShapeTextTypeToggle()
		this.renderShapeTextPropertyInput()
		this.renderSpecificTextInput()

		this.updateShapeSpecificTextVisibility()
		this.updateShapeTextPropertyVisibility()

		this.formView = new FormView({
			el: this.el,
			submit: () => this.submit()
		})

		this.formView.start()

		return this
	},

	/**
	 * Renders the shapeTextType toggle (ie "Field | Value | None")
	 */
	renderShapeTextTypeToggle () {
		this.shapeTextTypeToggle = new LabeledToggle({
			value: this.model.properties.get(SHAPE_TEXT_TYPE),
			options: this.getShapeTextTypeOptions()
		})

		this.$('.shape-text-type-toggle').append(this.shapeTextTypeToggle.el)
		this.shapeTextTypeToggle.render()

		this.shapeTextTypeToggle.on('change', () => this.onShapeTextTypeChange())
	},

	/**
	 * Returns options for the shapeTextType toggle
	 */
	getShapeTextTypeOptions () {
		let options = []

		if (!this.model.isNoneSource()) {
			options.push({
				value: DATA_SOURCE,
				label: 'dashboards.textType.dataSource'
			})
		}

		if (!this.model.isNoneSource() && !this.model.isDatasetSource()) {
			options.push({
				value: SPECIFIC_FIELD,
				label: 'dashboards.textType.otherField'
			})
		}

		options.push({
			value: SPECIFIC_TEXT,
			label: 'dashboards.textType.specificText'
		})

		options.push({
			value: NONE,
			label: 'common.none'
		})

		return options
	},

	onShapeTextTypeChange () {
		this.formView.change()
		this.updateShapeSpecificTextVisibility()
		this.updateShapeTextPropertyVisibility()
	},

	/**
	 * Renders the shapeSpecificText text input
	 */
	renderSpecificTextInput () {
		this.$('[name=shapeSpecificText]')
			.val(this.model.properties.get(SHAPE_SPECIFIC_TEXT))
	},

	updateShapeSpecificTextVisibility () {
		this.$('.shape-specific-text-section').toggleClass('is-not-displayed',
			this.shapeTextTypeToggle.val() !== SPECIFIC_TEXT)
	},

	/**
	 * Renders the shapeTextProperty dropdown input (ie the "Field" dropdown)
	 */
	renderShapeTextPropertyInput () {
		selects(this.$('[name=shapeTextProperty]'), {
			options: this.model.validShapeTextPropertyOptions(),
			selected: this.model.properties.get(SHAPE_TEXT_PROPERTY)
		})
	},

	updateShapeTextPropertyVisibility () {
		let hide = this.shapeTextTypeToggle.val() !== SPECIFIC_FIELD
		this.$('.shape-text-property-section').toggleClass('is-not-displayed', hide)
	},

	/**
	 * Returns the current values of the form inputs
	 */
	val () {
		return _.extend({
			shapeTextType: this.shapeTextTypeToggle.val(),
			// Initialize to null so they are unset if necessary
			shapeSpecificText: null,
			shapeTextProperty: null
		}, formHelper.readFromDom(this.el))
	},

	submit () {
		this.trigger('done', this.val())
	},

	autoRemove: true
})

export default ShapeTextConfigView

ShapeTextConfigView.__filename__ = 'dashboards/widgets/shape/config/shape-text-config-view.js'
